"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    ", ";\n"], ["\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n        text-align: center;\n        display: inline-block;\n        padding: ", "px;\n        margin-bottom: ", "em;\n    "], ["\n        text-align: center;\n        display: inline-block;\n        padding: ", "px;\n        margin-bottom: ", "em;\n    "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Progress = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject2, props.theme.steps.border, props.margin || props.theme.steps.margin);
});

var Steps = function (_React$Component) {
    _inherits(Steps, _React$Component);

    function Steps(props) {
        _classCallCheck(this, Steps);

        var _this = _possibleConstructorReturn(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).call(this, props));

        _this.state = {
            current: _this.props.current
        };
        return _this;
    }

    _createClass(Steps, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var _this2 = this;

            if (this.state.current != this.props.current) {
                var i = this.state.current;
                var target = this.props.current;
                var timer = setInterval(function () {
                    if (target > i) {
                        i++;
                    } else if (target < i) {
                        i--;
                    } else {
                        clearInterval(timer);
                    }
                    _this2.setState({ current: i });
                }, 80);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                stages = _props.stages,
                children = _props.children,
                barWidth = _props.barWidth,
                rest = _objectWithoutProperties(_props, ["stages", "children", "barWidth"]);

            var childrenWithProps = _react2.default.Children.map(this.props.children, function (child, i) {
                return _react2.default.cloneElement(child, {
                    i: i,
                    current: _this3.state.current,
                    hasBar: !Boolean(i == _react2.default.Children.count(_this3.props.children) - 1),
                    barWidth: barWidth
                });
            });
            return _react2.default.createElement(
                Progress,
                rest,
                childrenWithProps
            );
        }
    }]);

    return Steps;
}(_react2.default.Component);

Steps = (0, _styledComponents.withTheme)(Steps);

Steps.propTypes = {
    /** The current step */
    current: _propTypes2.default.number,
    /** Array of stages - shows the label and callback in an object. */
    stages: _propTypes2.default.array,
    /** The width of the lines between the dots */
    barWidth: _propTypes2.default.number,
    margin: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Steps.defaultProps = {
    barWidth: 10
};

Steps.displayName = "Steps";

exports.default = Steps;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/steps/steps.js
// module id = 455
// module chunks = 95715928098905 168707334958949